import { User } from '@shared/models/user.model';

export class Case {
  constructor(
    public validSeconds: number,
    public redirectUrl: string,
    public status: string,
    public name: string,
    public users: User[],
    public masterId: string,
    public entryId: string,
    public creationTime: string,
    public updateTime: string,
    public currentVersion: number,
  ) {}
}

